// import makeInspectable from 'mobx-devtools-mst';
import { Instance, types } from 'mobx-state-tree';
import { createContext, useContext } from 'react';
import AppStore from './apps';
import PromotionsStore from './cross-promotions';
import DialogStore from './dialogs';
import GlobalNotification from './global-notification/index';
import RegionConfigStore from './region-config';
import SessionStore from './session';
import SystemInfo from './system-info';
import UserInfo from './user-info';
import WindowInfo from './window/window-info';
import NotificationCenter, { INotificationCenter } from './notification-center';

const { win } = window;

const RootStore = types.model({
    appStore: types.optional(AppStore, {}),
    systemInfo: types.optional(SystemInfo, {}),
    session: types.optional(SessionStore, {}),
    promotions: types.optional(PromotionsStore, {}),
    regionConfig: types.optional(RegionConfigStore, {}),
    windowInfo: WindowInfo,
    userInfo: types.optional(UserInfo, {}),
    dialogs: types.optional(DialogStore, {}),
    globalNotification: types.optional(GlobalNotification, {}),
    notificationCenter: types.optional(NotificationCenter, {}),
});

export interface IAppsStore extends Instance<typeof AppStore> {}
export interface ISystemInfo extends Instance<typeof SystemInfo> {}
export interface ISessionStore extends Instance<typeof SessionStore> {}
export interface IPromotionsStore extends Instance<typeof PromotionsStore> {}
export interface IRegionConfigStore extends Instance<typeof RegionConfigStore> {}
export interface IWindowInfo extends Instance<typeof WindowInfo> {}
export interface IUserInfo extends Instance<typeof UserInfo> {}
export interface IDialogStore extends Instance<typeof DialogStore> {}

export interface IRootStore {
    appStore: IAppsStore;
    systemInfo: ISystemInfo;
    session: ISessionStore;
    promotions: IPromotionsStore;
    regionConfig: IRegionConfigStore;
    windowInfo: IWindowInfo;
    userInfo: IUserInfo;
    dialogs: IDialogStore;
    notificationCenter: INotificationCenter;
}

const RootStoreContext = createContext<IRootStore>({} as IRootStore);
export const RootStoreProvider = RootStoreContext.Provider;

export const rootStore = RootStore.create({
    windowInfo: {
        minimized: win.isMinimized(),
        maximized: win.isMaximized(),
        closed: !win.isVisible(),
    },
});

// makeInspectable(rootStore);
window.rootStore = rootStore;

export function useStore() {
    const store = useContext(RootStoreContext);
    if (store === null) {
        throw new Error('Store cannot be null, please add a context provider');
    }
    return store;
}

win.on('maximize', () => {
    rootStore.windowInfo.updateMaximize(true);
    rootStore.windowInfo.updateMiminize(false);
});
win.on('unmaximize', () => {
    rootStore.windowInfo.updateMaximize(false);
});

win.on('minimize', () => {
    rootStore.windowInfo.updateMiminize(true);
});
win.on('restore', () => {
    rootStore.windowInfo.updateMiminize(false);
});

win.on('close', () => {
    rootStore.windowInfo.updateClose(true);
});
win.on('show', () => {
    rootStore.windowInfo.updateClose(false);
});
